<template>
  <el-dialog
    class="dev-picker"
    title="批量加载模型"
    :visible.sync="dialogShow"
    width="900px"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :show-close="!dev_load_loading"
    append-to-body
    :before-close="close"
  >
    <div v-loading="loading" style="padding: 0 40px 0 40px;">
      <div v-if="step == 1">
        <div style="font-size: 18px;" class="text-green mt-md mb-md">将为下列 {{ list.length }} 台设备加载 <f-dev-selector v-model="devid" placeholder="选择模型" width="160" @change="loadDev"/> 模型</div>
        <el-scrollbar :native="false" v-loading="dev_load_loading">
          <el-table
            ref="devsTable"
            :data="list"
            tooltip-effect="dark"
            :row-style="{ height: '48px' }"
          >
            <el-table-column type="index" width="60" label="#"/>
            <el-table-column prop="go" label="设备名称" min-width="160" />
            <el-table-column :show-overflow-tooltip="true" label="模型" min-width="160">
              <div slot-scope="scope" style="line-height: 16px;">
                <div v-if="scope.row.devid && scope.row.devid != devid" class="text-danger">
                  <s>{{ scope.row.dev_name }}</s>
                </div>
                <div v-if="devid">{{ dev_name }}</div>
              </div>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <div v-else-if="step == 2">
        <div v-if="loading_result" style="font-size: 18px;" class="mt-md mb-md">
          <span v-if="success_num">成功加载 <span class="text-success">{{ success_num }}</span> 台设备</span>
          <span v-if="success_num && fail_num">，</span>
          <span v-if="fail_num">失败 <span class="text-danger">{{ fail_num }}</span> 台</span>
        </div>
        <el-scrollbar :native="false" ref="scrollbar">
          <el-table
            ref="devsTable2"
            :data="list2"
            tooltip-effect="dark"
            :row-style="{ height: '48px' }"
          >
            <el-table-column type="index" width="60" label="#"/>
            <el-table-column prop="go" label="设备名称" min-width="160" />
            <el-table-column :show-overflow-tooltip="true" label="模型" min-width="160">
              <template slot-scope="scope">
                <span>{{ scope.row.dev_name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="结果" align="center" min-width="80" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span v-if="scope.row.loading" style="font-size: 18px;color: #008ef8" class="el-icon-loading"></span>
                <span v-else :class="scope.row.status == 1 ? 'text-green' : 'text-danger'">
                  {{scope.row.status == 1 ? "成功" : scope.row.err_message}}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
    </div>
    <span slot="footer" class="dialog-footer flex justify-content-center">
      <el-button v-if="step == 1" @click="dialogShow = false">取 消</el-button>
      <el-button v-if="step == 1" type="primary" :disabled="!devid" @click="submit">提 交</el-button>
      <el-button v-if="step == 2" :disabled="dev_load_loading" @click="closeDialog">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { loadDevApi } from '@/api/rms/rmsEquipDevApi'

export default {
  name: "DevPicker",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,

      devid: null,
      step: 1,
      list2: [],
      dev_name: null,
      dev_load_loading: false,
      loading_result: false,
      success_num: 0,
      fail_num: 0,
    };
  },
  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      }
    }
  },
  created() {
    // console.log(this.list,'-------------');
  },
  methods: {
    async submit() {
      this.list2 = [];
      this.step = 2;
      for(let i = 0; i < this.list.length; i++) {
        this.dev_load_loading = true;
        const temp_item = Object.assign({},{...this.list[i]});
        this.list2.push(Object.assign({}, temp_item,{dev_name: this.dev_name,loading: true}));
        const res = await loadDevApi({ equipid: temp_item.equipid, devid: this.devid });
        if (!res.errno) {
          this.list2[i].loading = false;
          this.list2[i] = Object.assign({}, this.list2[i],{loading: false, status: 1});
        }else {
          this.list2[i].loading = false;
          this.list2[i] = Object.assign({}, this.list2[i],{loading: false, status: 0,err_message: res.message});
        }

        if (this.list2.length > 5) {
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
        if(i == this.list.length - 1) {
          this.dev_load_loading = false;
          this.loading_result = true;
          this.success_num = 0;
          this.fail_num = 0;
          for(let j = 0; j < this.list2.length; j++) {
            if(this.list2[j].status == 1) {
              this.success_num++;
            }else {
              this.fail_num++;
            }
          }
        }
      }
    },

    scrollToBottom() {
      const scrollbar = this.$refs.scrollbar;
      if (scrollbar) {
        scrollbar.wrap.scrollTop = scrollbar.wrap.scrollHeight;
      }
    },

    loadDev(e) {
      this.dev_name = e.dev_name;
    },

    closeDialog() {
      this.dialogShow = false;
      this.step = 1;
      this.devid = null;
      this.list2 = [];
      this.loading_result = false;
      this.success_num = 0;
      this.fail_num = 0;
      this.$emit('change')
    },

    close() {
      this.closeDialog()
    },
  }
};
</script>

<style lang="scss">
.dev-picker {
  .el-scrollbar {
    height: 480px;
    > .el-scrollbar__wrap {
      overflow-x: hidden;
      > .el-scrollbar__view {
        padding: 0 10px 80px 0;
      }
    }
  }
  .el-dialog__footer {
    padding-bottom: 30px;
  }
}
</style>
